import React from "react"
import classnames from "classnames"
import {
  Space,
  Interactive,
  P,
  Caption,
  Icon360Icon,
  CheckIcon
} from "AtomicComponents"
import styles from "./InteriorPicker.less"
import {
  Image,
  Image360,
  Tooltip,
  HeroContent,
  Tabs
} from "AtomicContainers"
import gtmHandler from "AtomicUtils/gtmHandler"

class InteriorPicker extends React.PureComponent {
  constructor(props){
    super(props)
    this.state = {
      activeIndex: 0,
      width: null,
      height: null
    }
    this.interiorPicker = {}
  }

  componentDidMount(){
    setTimeout(()=>{
      this._setDimension()
    }, 250)
  }

  _setDimension = () => {
    if (this.interiorPicker){
      this.setState({
        width: null
      }, () => {
        setTimeout(() => {
          let newWidth = this.interiorPicker.offsetWidth
          let newHeight = newWidth > 768 ? newWidth*0.5 : newWidth
          this.setState({
            width: this.interiorPicker.offsetWidth,
            height: newHeight,
          })
        }, 250)
      })
    }
  }

  _handleOnClick = (activeIndex) => {
    const { gtm, options = [] } = this.props
    this.setState({
      activeIndex: activeIndex
    }, () => {
      this._setDimension()
      if (gtm && gtm.category && gtm.action && gtm.category !== "" && gtm.action !== "") {
        gtmHandler({
          pageCategory: gtm.category,
          pageAction: `${gtm.action} - Clicked "${options[this.state.activeIndex].name}"`
        })
      }
    })
  }

  render() {
    const {
      heading,
      description,
      options = []
    } = this.props

    const { activeIndex, width, height } = this.state

    return (
      <div className={classnames({
        [styles.InteriorPicker]: true
      })}>
        { (heading || description) &&
        <HeroContent
          heading={heading}
          description={description} />
        }
        <div
          ref={c => this.interiorPicker = c}
          className={classnames({
            [styles.InteriorPickerContainer]: true,
          })}>
          <div
            className={classnames({
              [styles.TabsInside]: true,
            })}
          >
            <Tabs
              onClick={this._handleOnClick}
              scrolling
            >
              {options && options.map((option,index) => {
                return (
                  <div
                    key={`InteriorPicker-${index}`}
                    className={classnames({
                      [styles.InteriorPickerIcon]: true,
                      [styles.InteriorPickerIconActive]: activeIndex === index
                    })}
                  >
                    <div
                      className={classnames({
                        [styles.InteriorPickerIconInside]: true
                      })}>
                      <Image
                        type='withoutShowing'
                        src={option.icon}
                      />
                      <div
                        className={classnames({
                          [styles.InteriorPickerIconCheckIcon]: true
                        })}>
                        <CheckIcon style={{
                          color: 'white',
                          width: '1em',
                          height: '1em'
                        }}/>
                      </div>
                    </div>
                    <div
                    className={classnames({
                      [styles.InteriorPickerTooltip]: true,
                    })}>
                      <Tooltip size="small" position='bottomCenter' closeIcon={false}>
                        <P withoutMargin>
                          {option.name}
                        </P>
                      </Tooltip>
                    </div>
                  </div>
                )
              })}
            </Tabs>
          </div>
          <Space />
          <Space />
          <div data-key={`InteriorPickerContent-${activeIndex}`}>
            <div className={classnames({
              [styles.InteriorPickerNameForTablet]: true
            })}>
              <Interactive>
                {options[activeIndex].name}
              </Interactive>
            </div>
            <Space />
            <div className={classnames({
              [styles.InteriorPickerImage]: true
            })}
            >
              {options[activeIndex].image360 && width &&
                <div>
                  <Image360
                    src={options[activeIndex].image360}
                    width={width}
                    height={height}
                  />
                </div>
              }
              {(!options[activeIndex].image360) &&
                <div>
                  <Image
                  src={options[activeIndex].src}
                  />
                </div>
              }
              <div className={classnames({
                [styles.InteriorPickerDisclaimer]: true,
                [styles.InteriorPickerDisclaimer360]: options[activeIndex].image360
              })}>
                {options[activeIndex].image360 &&
                  <div className={classnames({
                    [styles.InteriorPickerDisclaimer360Text]: true,
                  })}>
                    <Caption white>
                      Drag to view 360°
                    </Caption>
                    <div  className={classnames({
                      [styles.InteriorPickerDisclaimer360TextIcon]: true,
                    })}>
                      <Icon360Icon />
                    </div>
                  </div>
                }
                {options[activeIndex].disclaimer &&
                  <Caption white>
                    {options[activeIndex].disclaimer}
                  </Caption>
                }
              </div>
            </div>
          </div>
        </div>

      </div>
    )
  }
}


export default InteriorPicker



// WEBPACK FOOTER //
// ./src/AtomicContainers/InteriorPicker/InteriorPicker.jsx